import React from "react";
import dayjs from 'dayjs';
import { DatePicker, Space, Table, Select,Badge, Alert, Typography, message, Image, Button, Input } from 'antd';
import { useApiSelector, useDrawer } from 'src/hooks'
import { useRequest, dispatchAsync } from 'friday-async'
import { ActivityType, SendStatus, SendStatusName, ActivityTypeMap, leadsBizCodeName, sendMsgWhite } from './constants';
import { useExcelService } from './useExcelService';
import config from '../../config'
import ModalStatus from './ModalStatus';
import CardKeyModal from './CardKeyModal';

const { RangePicker } = DatePicker;


const sourceMap = {
    'media': '离线录入',
    'alipay_shijia': '支付宝广告',
    'h5': 'H5广告',
}

const smsTempMap = {
    [ActivityType.alipay_mini_2604]: '2641590',
    [ActivityType.alipay_mini_2605]: '2641590',
    [ActivityType.alipay_mini_2605_series]: '2641604',
}


const dateFormat = 'YYYY-MM-DD'
const Analysis = () => {
    const apis = useApiSelector();
    const { onDownloadLeads } = useExcelService();
    const [loading, setLoading] = React.useState(false)

    // 当前活动的短信配置（从平台活动数据动态获取）
    const [smsEnabled, setSmsEnabled] = React.useState(false)
    const [smsTemplateId, setSmsTemplateId] = React.useState('')

    const [filterInfo, setFilterInfo] = React.useState({
        startTime: dayjs(),
        endTime: dayjs(),
        isNew: 'all' as any,
        status: SendStatus.All as any,
        jobName: ActivityType.alipay_h5_202608,
        isQueryReceiveResult: false,
        source: 'all' as any,
        tel: '',
    })

    
    const [selectedRowKeys, setSelectedRowKeys] = React.useState<any[]>([]);
    const selectRowsRef = React.useRef<any[]>([]);
    const [cardKeyModalInfo, setCardKeyModalInfo] = React.useState<{
        visible: boolean;
        sendInfos: any[];
    }>({ visible: false, sendInfos: [] });


    const requestBody = React.useMemo(() => {
        return {
            ...filterInfo,
            startTime: dayjs(filterInfo.startTime).format(dateFormat),
            endTime: dayjs(filterInfo.endTime).format(dateFormat)
        }
    }, [filterInfo])

    const { dataArray, isValidating, revalidate } = useRequest(apis.analysis.getLeads(requestBody))

    // 根据当前选中的活动 code 动态获取短信配置
    const smsRequestBody = React.useMemo(() => ({ code: filterInfo.jobName }), [filterInfo.jobName])
    const { dataArray: activitySmsData } = useRequest(apis.activity.getByCode(smsRequestBody))
    React.useEffect(() => {
        if (activitySmsData) {
            const smsData = activitySmsData as any
            setSmsEnabled(smsData.smsEnabled || false)
            setSmsTemplateId(smsData.smsTemplateId || '')
        } else {
            setSmsEnabled(false)
            setSmsTemplateId('')
        }
    }, [activitySmsData])

    const Drawer = useDrawer(revalidate);

    const onUpdateFilter = (nextValueField) => {
        
        setFilterInfo({
            ...filterInfo,
            ...nextValueField
        })
        onSelectRowKeys([])
    }
    const batchSendMsg = (sendInfos?: any[]) => {
        let nextSendInfos = sendInfos;

        if (!nextSendInfos) {
            nextSendInfos = selectRowsRef.current;
        }

        const filterUnSendMsg = nextSendInfos?.filter(i => i.isSendShotMsg !== SendStatus.Send)

        if (!filterUnSendMsg.length) {
            return message.error('没有未发送短信的线索')
        }

        if (filterUnSendMsg.length > 10) {
            return message.error('请勿一次发送大于10条短信')
        }

        setCardKeyModalInfo({ visible: true, sendInfos: filterUnSendMsg });
    };

    const handleCardKeyConfirm = (sdkKeys: string[]) => {
        const { sendInfos } = cardKeyModalInfo;
        const promises = sendInfos.map((i, index) => {
            return dispatchAsync(apis.analysis.sendShotMsg({
                tempId: smsTempMap[i.jobName] || '',
                userId: i._id,
                phone: i.tel,
                jobName: i.jobName,
                cardKey: sdkKeys?.[index] || ''
            }))
        })
        setLoading(true);
        setCardKeyModalInfo({ visible: false, sendInfos: [] });
        Promise.all(promises).then(() => {
            message.success('短信发送成功');
            setLoading(false);
            revalidate();
            onSelectRowKeys([])
        });
    };

    const deleteLead = async (_id) => {
        await dispatchAsync(apis.analysis.delete({
            _id, 
        }))

        revalidate()
    }

    const onDownloadLeadsHandel = () => {
        const downloadData = selectRowsRef.current.map(i => {
            const { seriesId, } = i.leadInfo || {};
            return {
                ...i,
                seriesId,
                assest: i.assest?.[0]
            }
        });

        onDownloadLeads(
            `${filterInfo.startTime.format('YYYYMMDD')}-${filterInfo.endTime.format('YYYYMMDD')}-${filterInfo.jobName}`, 
            downloadData
        )
    }
   

    const onSelectRowKeys = (rowIds) => {
        const rows = dataArray.filter(i => rowIds.indexOf(i._id) > -1)
        selectRowsRef.current = rows;
        setSelectedRowKeys(rowIds)
    }

    const rowSelection = {
        selectedRowKeys,
        selections: [
            Table.SELECTION_ALL,
            Table.SELECTION_INVERT,
            Table.SELECTION_NONE,
        ],
        onChange: (rowIds) => onSelectRowKeys(rowIds),
    };

    const countUnsendMsg = selectRowsRef.current.filter(i => i.isSendShotMsg !== SendStatus.Send)?.length

    console.log(selectRowsRef.current, 'selectRowsRef')
    return (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            <Space>
                线索时间：
                <RangePicker
                    format={'YYYY-MM-DD'}
                    value={[filterInfo.startTime, filterInfo.endTime]}
                    onChange={(values) => {
                        onUpdateFilter({
                            startTime: values![0],
                            endTime: values![1],
                        })
                    }}
                />
                线索推送状态
                <Select
                    value={filterInfo.status}
                    style={{ width: 120 }}
                    onChange={(val) => {
                        onUpdateFilter({status: val})
                    }}
                    dropdownStyle={{width: 200}}
                    options={[
                        { value: SendStatus.All, label:  SendStatusName[SendStatus.All].title},
                        { value: SendStatus.Send, label:  SendStatusName[SendStatus.Send].title},
                        { value: SendStatus.unSend, label: SendStatusName[SendStatus.unSend].title },
                        { value: SendStatus.Fail, label: SendStatusName[SendStatus.Fail].title },
                    ]}
                />
                 会员类型
                 <Select 
                    style={{ width: 120 }}
                    value={filterInfo.isNew}
                    onChange={(val) => {
                        onUpdateFilter({isNew: val})
                    }}
                    allowClear
                 >
                    <Select.Option value={'all'}>全部</Select.Option>
                    <Select.Option value={1}>新客</Select.Option>
                    <Select.Option value={0}>老客</Select.Option>
                 </Select>

                当前活动
                <Select
                    value={filterInfo.jobName}
                    style={{ width: 200 }}
                    onChange={(val) => {    
                        onUpdateFilter({jobName: val})
                    }}
                    dropdownStyle={{width: 300}}
                    options={[
                        { value: ActivityType.alipay_h5_202608, label: ActivityTypeMap[ActivityType.alipay_h5_202608].text},
                        { value: ActivityType.alipay_mini_2605, label:  ActivityTypeMap[ActivityType.alipay_mini_2605].text },
                        { value: ActivityType.alipay_mini_2604, label:  ActivityTypeMap[ActivityType.alipay_mini_2604].text },
                        { value: ActivityType.alipay_h5_202605, label: ActivityTypeMap[ActivityType.alipay_h5_202605].text},
                        { value: ActivityType.alipay_mini_2605_series, label: ActivityTypeMap[ActivityType.alipay_mini_2605_series].text},
                        { value: ActivityType.alipay_mini_2507, label: ActivityTypeMap[ActivityType.alipay_mini_2507].text},
                        { value: ActivityType.toyota_20250601_vip, label: ActivityTypeMap[ActivityType.toyota_20250601_vip].text},
                        { value: ActivityType.toyota_20250601_lead, label: ActivityTypeMap[ActivityType.toyota_20250601_lead].text},
                        { value: ActivityType.haobing_20250801, label: ActivityTypeMap[ActivityType.haobing_20250801].text},
                        { value: ActivityType.alipay_spi_1103, label: ActivityTypeMap[ActivityType.alipay_spi_1103].text},
                        { value: ActivityType.job_benz_11_24, label: ActivityTypeMap[ActivityType.job_benz_11_24].text},
                        { value: ActivityType.alipay_mini_program_0208, label: ActivityTypeMap[ActivityType.alipay_mini_program_0208].text},
                        { value: ActivityType.alipay_mini_program_1103, label: ActivityTypeMap[ActivityType.alipay_mini_program_1103].text},
                        { value: ActivityType.alipay_mini_program_0127, label: ActivityTypeMap[ActivityType.alipay_mini_program_0127].text},
                        { value: ActivityType.alipay_mini_program_quanyi_1120, label: ActivityTypeMap[ActivityType.alipay_mini_program_quanyi_1120].text},
                        { value: ActivityType.alipay_mini_program_member_1120, label: ActivityTypeMap[ActivityType.alipay_mini_program_member_1120].text},
                        // { value: ActivityType.puladuo_baoke_jiayou_20240804, label: ActivityTypeMap[ActivityType.puladuo_baoke_jiayou_20240804].text},
                        // { value: ActivityType.puladuo_baoke_jiudian_20240804, label:  ActivityTypeMap[ActivityType.puladuo_baoke_jiudian_20240804].text},
                        // { value: ActivityType.puladuo_qianke_20240804, label:  ActivityTypeMap[ActivityType.puladuo_qianke_20240804].text},
                        // { value: ActivityType.YAZHOULONG, label:  ActivityTypeMap[ActivityType.YAZHOULONG].text},
                        // { value: ActivityType.avalon_20240804_test, label:  ActivityTypeMap[ActivityType.avalon_20240804_test].text },
                        { value: ActivityType.test_20240808, label:  ActivityTypeMap[ActivityType.test_20240808].text },
                        
                    ]}
                />

                {/* 线索来源 */}
                线索来源
                <Select 
                    style={{ width: 120 }}
                    value={filterInfo.source}
                    onChange={(val) => {
                        onUpdateFilter({source: val})
                    }}
                    allowClear
                 >
                    <Select.Option value={'all'}>全部</Select.Option>
                    {Object.keys(sourceMap).map((key) => (
                        <Select.Option key={key} value={key}>{sourceMap[key]}</Select.Option>
                    ))}
                 </Select>
                 {/* 手机号 */}
                 手机号
                 <Input
                    value={filterInfo.tel}
                    style={{ width: 200 }}
                    onChange={(e) => {
                        onUpdateFilter({tel: e.target.value})
                    }}
                    allowClear
                 />
                 <Typography.Text>共{dataArray.length}条</Typography.Text>

                
            </Space>

            <Space direction="vertical">
                {selectedRowKeys.length ? (
                    <Space>
                        <Typography.Text>{`当前选择了 ${selectedRowKeys.length}条：`}</Typography.Text>
                        {sendMsgWhite.includes(filterInfo.jobName) ? (
                            <Button type='primary' loading={loading} onClick={() => batchSendMsg()} ghost>批量发送短信（未发送{countUnsendMsg}）</Button>
                        ): null}
                        <Button type='primary'  onClick={() => onDownloadLeadsHandel()} ghost>下载报表</Button>
                    </Space>
                ): null}   
            </Space>

            <Table
                rowKey='_id'
                loading={isValidating}
                scroll={{ x: 1800 }}
                rowSelection={rowSelection}
                columns={[
                    {
                        title: 'id',
                        dataIndex: '_id',
                        key: '_id',
                        width: 160,
                    },
                    {
                        title: '手机号',
                        dataIndex: 'tel',
                        key: 'tel',
                        width: 140,
                    },
                    {
                        title: '活动类型',
                        dataIndex: 'jobName',
                        key: 'jobName',
                        width: 140,
                        render(jobName) { 
                            return ActivityTypeMap[jobName]?.text || jobName;
                        }
                    },
                    {
                        title: '车系',
                        dataIndex: 'seriesId',
                        key: 'seriesId',
                        width: 60,
                        render(_, record) { 
                            return record.leadInfo?.seriesId;
                        }
                    },
                    {
                        title: '会员类型',
                        dataIndex: 'memberType',
                        key: 'memberType',
                        width: 120,
                        render(_, record) { 
                            if (record?.isNew === undefined) {
                                return '--';
                            }
                            return record?.isNew === 1 ? '新客' : '老客';
                        }
                    },
                    {
                        title: '线索来源',  
                        dataIndex: 'source',
                        key: 'source',
                        width: 120,
                        render(source) {
                            return sourceMap[source] || '--';
                        }
                    },
                    {
                        title: '权益成功数',
                        dataIndex: 'receiveSuccessLenth',
                        key: 'receiveSuccessLenth',
                        width: 110,
                    },
                    {
                        title: '权益成功ID',
                        dataIndex: 'receiveSuccessCouponId',
                        key: 'receiveSuccessCouponId',
                        width: 120,
                    },
                    {
                        title: '权益失败数',
                        dataIndex: 'receiveFailLenth',
                        key: 'receiveFailLenth',
                        width:120,
                    },
                    {
                        title: '权益失败明细',
                        dataIndex: 'receiveFailComment',
                        key: 'receiveFailComment',
                        width: 160,
                    },
                    {
                        title: '创建时间',
                        dataIndex: 'createTime',
                        key: 'createTime',
                        width: 120,
                    },
                    {
                        title: '审核状态',
                        dataIndex: 'leadsBizCode',
                        key: 'leadsBizCode',
                        width: 100,
                        render(val, record) {
                            const map: Record<string, { text: string; color: string }> = {
                                issued: { text: '待审核', color: 'orange' },
                                fail_finished: { text: '已驳回', color: 'red' },
                                success_finished: { text: '已通过', color: 'green' },
                            };
                            const item = map[val] || { text: '-', color: 'default' };
                            return <Badge text={item.text} color={item.color} />;
                        }
                    },
                    {
                        title: '一丰回传',
                        dataIndex: 'sendStatus',
                        key: 'sendStatus',
                        width: 100,
                        render(val) {
                            return  <Badge text={SendStatusName[val]?.title} color={SendStatusName[val]?.color} />
                        }
                    },
                    {
                        title: '发送短信',
                        dataIndex: 'isSendShotMsg',
                        key: 'isSendShotMsg',
                        width: 100,
                        render(val) {
                            return  <Badge text={SendStatusName[val]?.title} color={SendStatusName[val]?.color} /> 
                        }
                    },
                    {
                        title: '销售合同',
                        dataIndex: 'img',
                        key: 'img',
                        render(_, record) {
                            const url =  record.assest?.[0] ? config.imgHost + record.assest?.[0] : undefined;
                            return url ? 
                                <Image
                                    width={50}
                                    src={url}
                                /> : '未上传'
                        }
                    },
                    {
                        title: '合同状态',
                        dataIndex: 'leadsBizCode',
                        key: 'leadsBizCode',
                        render: (val) => {
                            return   <Badge text={leadsBizCodeName[val]?.title} color={leadsBizCodeName[val]?.color} /> 
                        }
                    },
                    {
                        title: '合同同步状态',
                        dataIndex: 'leadsSyncStatus',
                        key: 'leadsSyncStatus',
                        render: (val) => {
                            return   <Badge text={SendStatusName[val]?.title} color={SendStatusName[val]?.color} /> 
                        }
                    },
                    {
                        title: 'ocpc回传',
                        dataIndex: 'conversionStatus',
                        key: 'conversionStatus',
                        render(val) {
                            return  <Badge text={SendStatusName[val]?.title} color={SendStatusName[val]?.color} /> 
                        }
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        key: 'oper',
                        fixed: 'right',
                        width: 200,
                        render(val, record) {
                            const { isSendShotMsg, jobName,_id } = record
                            const unDisabled = sendMsgWhite.includes(jobName) && isSendShotMsg !== SendStatus.Send;
                            return  (
                                <Space>
                                    {/* 审核 */}
                                    <Typography.Link 
                                        onClick={() => Drawer.onOpen(record)}
                                        disabled={!record.leadsBizCode || record.leadsBizCode === 'success_finished'}
                                    >合同审核</Typography.Link>
                                    <Typography.Link 
                                        onClick={() => batchSendMsg([record])}
                                        disabled={!unDisabled} 
                                    >发送短信</Typography.Link>
                                    <Typography.Link 
                                        onClick={() => deleteLead(_id)}
                                    >删除</Typography.Link>
                                </Space>
                            ) 
                        }
                    },
                ]}
                dataSource={dataArray}
            />
            {Drawer.visible &&
                <ModalStatus
                    record={Drawer.record}
                    onCancel={() => Drawer.onClose()}
                    visible={Drawer.visible}
                    onFinishAndRevalidate={Drawer.onFinishAndRevalidate}
                />
            }
            {cardKeyModalInfo.visible && (
                <CardKeyModal
                    visible={cardKeyModalInfo.visible}
                    sendInfos={cardKeyModalInfo.sendInfos}
                    onCancel={() => setCardKeyModalInfo({ visible: false, sendInfos: [] })}
                    onOk={handleCardKeyConfirm}
                />
            )}
        </Space>
    )
}

export default Analysis;